import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, Home, HelpCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        {/* Cancel Icon */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-orange-500 to-red-600 rounded-full mb-6">
            <XCircle className="w-16 h-16 text-white" />
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Paiement Annulé
          </h1>
          
          <p className="text-xl text-gray-300">
            Votre paiement n'a pas été effectué. Aucun montant n'a été débité.
          </p>
        </div>

        {/* Info Card */}
        <div className="bg-gray-800/50 rounded-2xl p-8 border border-orange-500/30 mb-8">
          <h2 className="text-2xl font-semibold text-orange-400 mb-4">
            Que s'est-il passé ?
          </h2>
          
          <p className="text-gray-300 mb-6">
            Vous avez annulé le processus de paiement avant sa finalisation. 
            Votre réservation n'a pas été confirmée et aucun montant n'a été débité de votre compte.
          </p>

          <div className="p-4 bg-orange-500/10 border border-orange-500/30 rounded-lg">
            <p className="text-orange-400 text-sm">
              💡 Si vous avez rencontré un problème technique, n'hésitez pas à nous contacter.
            </p>
          </div>
        </div>

        {/* Options */}
        <div className="bg-gray-800/30 rounded-2xl p-6 border border-gray-700 mb-8">
          <h3 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
            <HelpCircle className="w-5 h-5 text-gold" />
            Que Faire Maintenant ?
          </h3>
          <ul className="space-y-3 text-gray-300">
            <li className="flex items-start gap-3">
              <span className="text-gold">•</span>
              <span>
                <strong>Réessayer le paiement</strong> - Retournez à votre réservation pour effectuer le paiement
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-gold">•</span>
              <span>
                <strong>Contacter le support</strong> - Notre équipe peut vous aider si vous rencontrez des difficultés
              </span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-gold">•</span>
              <span>
                <strong>Payer autrement</strong> - Vous pouvez aussi payer directement au chauffeur
              </span>
            </li>
          </ul>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <Button
            onClick={() => navigate('/')}
            size="lg"
            className="flex-1 bg-gradient-to-r from-gold to-amber-600 hover:from-gold/90 hover:to-amber-600/90 text-black font-semibold"
          >
            <Home className="w-5 h-5 mr-2" />
            Retour à l'Accueil
          </Button>
          
          <Button
            onClick={() => navigate(-2)}
            size="lg"
            variant="outline"
            className="flex-1 border-gold/30 text-gold hover:bg-gold/10"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à la Réservation
          </Button>
        </div>

        {/* Support Info */}
        <div className="mt-8 text-center">
          <div className="bg-gray-800/50 rounded-xl p-6 border border-gray-700">
            <h4 className="text-white font-semibold mb-3">
              Besoin d'Aide ?
            </h4>
            <p className="text-gray-300 text-sm mb-4">
              Notre équipe est disponible 24h/24 pour vous assister
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center text-sm">
              <a
                href="tel:+3223150254"
                className="text-gold hover:underline font-semibold"
              >
                📞 +32 2 315 02 54
              </a>
              <span className="hidden sm:inline text-gray-600">|</span>
              <a
                href="mailto:contact@luxurytransferservices.be"
                className="text-gold hover:underline font-semibold"
              >
                ✉️ contact@luxurytransferservices.be
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
